import React,{useState} from 'react'
import './ChatInput.css'
import {useStateValue} from './StateProvider'
import db from '../Firebase'
import firebase from 'firebase'
import './ChatInput.css'

function ChatInput({channelName,channelId}) {
    const [input,setInput]=useState('')
    const [{user}]=useStateValue()

    const handleSubmit = (e) => {
        e.preventDefault();
        if(channelId){
                db.collection("rooms").doc(channelId).collection("messages").add({
                    message:input,
                    time : firebase.firestore.FieldValue.serverTimestamp(),
                    user:user.displayName,
                    userImage:user.photoURL,
                })
        }
        setInput("");
    }
    return (
        <div  className="chatinput">
            <form>
                <input value={input} onChange={e => setInput(e.target.value)} type="text" placeholder={`Message #${channelName?.toLowerCase()}`} />
                <button type="submit" onClick={handleSubmit}>Send</button>
            </form>
        </div>
    )
}

export default ChatInput
